0 <template>
	<Card>
		<div class="yl-flex">
			<div class="yl-flex" style="width: 380px">
				<Input v-model="name" style="width: 250px" placeholder="请输入名称">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
				<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
				<Button class='ivu-btn-circle' type="primary" @click="addSubsidiary">添加分公司</Button>
			</div>			
		</div>
		<div style="margin-top: 20px;">
			<Table size="small" :columns="columns" :data="data" >
				<template slot-scope="{ row }" slot="action">
					<Button class='ivu-btn-circle' :data-id="row.id" @click="editSubsidiary" type="warning"
						size="small">编辑</Button>
					<Button class='ivu-btn-circle' :data-id="row.id" @click="delSubsidiary" style="margin-left: 10px"
						size="small">删除</Button>
				</template>
				<template slot-scope="{index, row}" slot="is_open">
					<i-switch v-model="data[index].is_open" @on-change="saveOpen($event, index)" />
				</template>
			</Table>
			<div class="pager">
				<Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small" show-total
					show-elevator />
			</div>
		</div>
		<!--
		
		<Modal v-model="modal" width="1300" ok-text="添加保存">
			<div class="add_flex">
				<div class="add_title" @click="uploadModal = true">logo上传</div>
				<div><img :src="filiale.ext_info.logo"
						style="width: 80px; height: 35px; vertical-align: middle; margin-right: 5px" /><Button
						type="primary" @click="uploadLogo">上传图标</Button></div>
				<div class="add_title">品牌负责人</div>
				<Select v-model="filiale.charge_id" style="width:150px" placeholder="请选择品牌负责人">
					<Option v-for="item in functionaryList" :value="item.value" :key="item.value">{{ item.label }}
					</Option>
				</Select>
				<div class="add_title">渠道名称</div>
				<Input v-model="filiale.name" style="width: 150px" />
				<div class="add_title">开通时间</div>
				<DatePicker :value="filiale.open_at" type="date" style="width: 150px"
					@on-change="(e) => {filiale.open_at = e}"></DatePicker>
				<div class="add_title">到期时间</div>
				<DatePicker :value="filiale.expired_at" type="date" style="width: 150px"
					@on-change="(e) => {filiale.expired_at = e}"></DatePicker>
			</div>
			<div class="add_flex">
				<div class="add_title">渠道类型</div>
				<Select v-model="filiale.channel_type" style="width:150px">
					<Option v-for="item in channel_type_list" :value="item.value" :key="item.value">{{ item.label }}
					</Option>
				</Select>
		
				<div class="add_title">数据接受量(天)</div>
				<Input v-model="filiale.day_limit" style="width: 100px" />
				<div class="add_title">数据分发优先级别</div>
				<Select v-model="filiale.priority" style="width:150px">
					<Option v-for="item in priority_list" :value="item.value" :key="item.value">{{ item.label }}
					</Option>
				</Select>
				<div class="add_title">城市选择</div>
				<Cascader :data="cityData" v-model="filiale.ext_info.city"></Cascader>
			</div>
			<div class="add_flex">
				<div class="add_title">结算方式</div>
				<RadioGroup v-model="filiale.settle_type" style="display: flex; align-items: center;">
					<Radio :label="1"><span>利润金额</span></Radio>
					<Input v-model="filiale.settle_money" style="margin: 0 20px; width: 200px;">
					<span slot="append">元</span>
					</Input>
					<Radio :label="2"><span>结算比例</span></Radio>
					<Input v-model="filiale.settle_proportion" style="margin: 0 20px;width: 200px;">
					<span slot="append">%</span>
					</Input>
					<div style="width: 200px;">(例：110%,则是成本价格110%)</div>
				</RadioGroup>
			</div>
			<div class="add_flex">
				<div class="add_title">登录账号</div>
				<Input v-model="filiale.phone" style="width: 150px" />
		
				<div class="add_title">坐席数量</div>
				<Input v-model="filiale.team_nums" style="width: 150px" />
				<div class="add_title">坐席费用</div>
				<Input v-model="filiale.team_per_fee" style="margin: 0 20px; width: 200px;">
				<span slot="append">元/月</span>
				</Input>
				<div class="add_title">数据进线时间</div>
				<TimePicker v-model="filiale.quantum" format="HH:mm" type="timerange" placement="bottom-end"
					style="width: 150px"></TimePicker>
			</div>
			<div class="add_flex">
				<div style="margin: 0 10px; height: 100px; font-weight: bold; width: 57px;">客户来源</div>
				<div style="width: 1100px; border: 1px solid #DCDEE2; padding: 0 10px;">
					<div class="add_flex">
						<div class="add_title">添加媒体代码</div>
						<Select v-model="client_source.id" @on-select="changeMediumCode" style="width:150px">
							<Option v-for="item in mediumList" :value="item.value" :key="item.value">
								{{ item.label }}
							</Option>
						</Select>
						<div class="add_title">接受条件开关</div>
						<RadioGroup v-model="client_source.condition_check" style="display: flex; align-items: center;">
							<Radio :label="1"><span>开</span></Radio>
							<Radio :label="-1"><span>关</span></Radio>
						</RadioGroup>
						<div class="add_title">年龄</div>
						<Input v-model="client_source.age[0]" style="width: 50px;" />
						<div class="add_title">--</div>
						<Input v-model="client_source.age[1]" style="width: 50px;" />
						<div class="add_title">周岁</div>
						<div class="add_title">额度</div>
						<Input v-model="client_source.sum[0]" style="width: 50px;" />
						<div class="add_title">--</div>
						<Input v-model="client_source.sum[1]" style="width: 50px;" />
						<div class="add_title">元</div>
					</div>
				</div>
				<Button type="primary" style="height: 48px; " @click="addMediumCode">添加</Button>
			</div>
			<div class="add_flex" style="height: 32px;">
				<div class="add_title">接受选择条件</div>
				<CheckboxGroup v-model="client_source.entry_requirements">
					<Checkbox label="1"><span>全款房</span></Checkbox>
					<Checkbox label="2"><span>月供房</span></Checkbox>
					<Checkbox label="3"><span>全款车</span></Checkbox>
					<Checkbox label="4"><span>月供车</span></Checkbox>
					<Checkbox label="5"><span>社保</span></Checkbox>
					<Checkbox label="6"><span>公积金</span></Checkbox>
					<Checkbox label="7"><span>代发工资</span></Checkbox>
					<Checkbox label="8"><span>商业保险</span></Checkbox>
					<Checkbox label="9"><span>微粒贷</span></Checkbox>
					<Checkbox label="10"><span>信用卡</span></Checkbox>
					<Checkbox label="11"><span>芝麻信用</span></Checkbox>
				</CheckboxGroup>
			</div>
			<div class="add_flex" v-if="filiale.ext_info.medium_code_list.length > 0">
				<div class="add_title">已选媒体</div>
				<div style="width: 80%">
					<Tag v-for="(item,index) in filiale.ext_info.medium_code_list" @click.native="editMediumCode"
						:data-index="index" closable @on-close="cancelMediumCode" :name="item.id" :key="item.id">
						{{item.name}}</Tag>
				</div>
			</div>
		
			<div slot="footer">
				<Button type="primary" @click="save()">保存</Button>
			</div>
		</Modal>
-->
		<!-- 新增分公司 -->
		<Modal v-model="modal" width="1300" ok-text="添加保存">
			<Row>
				<Col span="6">
				<div> <span class="add_title">logo上传</span><img :src="filiale.ext_info.logo"
						style="width: 80px; height: 35px; vertical-align: middle; margin-right: 5px" /><Button
						type="primary" @click="uploadLogo">上传图标</Button></div>
				</Col>
				<Col span="6">
				<span class="add_title">品牌负责人</span>
				<Select v-model="filiale.charge_id" style="width:150px" placeholder="请选择品牌负责人">
					<Option v-for="item in functionaryList" :value="item.value" :key="item.value">{{ item.label }}
					</Option>
				</Select></Col>
				<Col span="6">
				<span class="add_title">渠道名称</span>
				<Input v-model="filiale.name" style="width: 150px" /></Col>
				<Col span="6">
					<span style="margin: 0 10px;font-weight: bold;">城市</span>
					<Input v-model="filiale.city" style="width: 150px" />
					<!--Cascader :data="cityData" style="width:250px;float: right;" v-model="filiale.ext_info.city"></Cascader-->
				</Col>	
			</Row>
			<Row style="padding-top: 20px;">
				<Col span="6">
					<span class="add_title">渠道类型</span>
					<Select v-model="filiale.channel_type" style="width:150px">
						<Option v-for="item in channel_type_list" :value="item.value" :key="item.value">{{ item.label }}
						</Option>
					</Select>
				</Col>
				<Col span="6">
				<span class="add_title">开通时间</span>
				<DatePicker :value="filiale.open_at" type="date" style="width: 150px"
					@on-change="(e) => {filiale.open_at = e}"></DatePicker>
				</Col>
				<Col span="6">
				<span class="add_title">到期时间</span>
				<DatePicker :value="filiale.expired_at" type="date" style="width: 150px"
					@on-change="(e) => {filiale.expired_at = e}"></DatePicker>
				</Col>
			</Row>
			<Row style="padding-top: 20px;">
				<Col span="6">
					<span class="add_title">登录账号</span>
					<Input v-model="filiale.phone" style="width: 150px" />
				</Col>	
				<Col span="6">
					<span class="add_title">坐席数量</span>
					<Input v-model="filiale.team_nums" style="width: 150px" />
				</Col>	
				<Col span="6">
					<span class="add_title">坐席费用</span>
					<Input v-model="filiale.team_per_fee" style=" width: 150px;">
					</Input>
				</Col>
			</Row>
			<Row style="padding-top: 20px;">
				<Col span="12">
					<span class="add_title">关联老系统渠道id</span>
					<Select v-model="filiale.old_system_id" style=" width: 150px;">
						<Option v-for="item in clientIdList" :value="item.id" :key="item.id">{{item.username }}-[{{item.id}}]
						</Option>
					</Select>
				</Col>
			</Row>
			<!--div class="add_flex" style="height: 32px;">
				<div class="add_title">接收条件</div>
				<CheckboxGroup v-model="filiale.condition_limit">
					<Checkbox label="1"><span>全款房</span></Checkbox>
					<Checkbox label="2"><span>月供房</span></Checkbox>
					<Checkbox label="3"><span>全款车</span></Checkbox>
					<Checkbox label="4"><span>月供车</span></Checkbox>
					<Checkbox label="5"><span>社保</span></Checkbox>
					<Checkbox label="6"><span>公积金</span></Checkbox>
					<Checkbox label="7"><span>代发工资</span></Checkbox>
					<Checkbox label="8"><span>商业保险</span></Checkbox>
					<Checkbox label="9"><span>微粒贷</span></Checkbox>
					<Checkbox label="10"><span>信用卡</span></Checkbox>
					<Checkbox label="11"><span>芝麻信用</span></Checkbox>
				</CheckboxGroup>
			</div-->
			<Row>
				<Col span="2">
					<span class="add_title">接收媒体代码</span>
				</Col>
				<Col span="20">
				<Checkbox :value="checkAll" @click.prevent.native="handleCheckAll" :indeterminate="indeterminate"><span>全选</span></Checkbox>
				<CheckboxGroup v-model="filiale.medium_code_list" @on-change="checkAllGroupChange">
					<Checkbox v-for="item in mediumList" :label="item.value"><span>{{item.label}}:{{item.id}}</span></Checkbox>
				</CheckboxGroup>
				</Col>
			</Row>
			<div slot="footer">
				<Button type="primary" @click="save()">保存</Button>
			</div>
		</Modal>
		<Modal v-model="uploadModal" title="上传图片" @on-cancel="() => {uploadModal = false}" @on-ok="fileOk">
			<addFile ref="addFile" :needFileName="0" :fileFormat="['jpg','jpeg','png','gif']"></addFile>
		</Modal>
	</Card>
</template>
<script>
	import addFile from '../tool/addFile.vue';
	import cityData from '../../assets/citydata.js';
	import {getClientIdList} from "../../api/finance";
	import {
		getAllCharge,
		getAllMediumCode,
		getSubsidiaryList,
		saveSubsidiary,
		getSubsidiary,
		delSubsidiary,
		saveSubsidiaryOpen
	} from '@/api/runSet'
	import {
		mapGetters,
		mapActions
	} from "vuex";

	export default {
		name: "JuniorManage",
		components: {
			addFile
		},
		computed: {
			...mapGetters(['userInfo', 'token']),
		},
		created() {
			this.loadData();
			this.getList();
		},
		data() {
			return {
				media_list: [],
				client_source: {
					id: '',
					name: '',
					condition_check: 1,
					age: ['', ''],
					sum: ['', ''],
					entry_requirements: []
				},
				mediumList: [],
				count: 0,
				page: 1,
				indeterminate: true,
				checkAll: false,
				uploadModal: false,
				cityData: cityData,
				uploadList: [],
				unloadButtonText: '上传logo',
				filiale: {
					charge_id: '',
					phone_readonly: false,
					name: '',
					created_at: '',
					expired_at: '',
					channel_type: 1,
					day_limit: '',
					city: '',
					quantum: ['9:00', '22:00'],
					settle_type: 1,
					settle_money: '',
					settle_proportion: '',
					phone: '',
					open_at: '',
					team_nums: '',
					condition_limit:[],
					team_per_fee: '',
					ext_info: {
						logo: '',
						city: [],
						medium_code_list: []
					},
					medium_code_list: [],
					sort: '',
				},
				functionaryList: [],
				channel_type_list: [{
						label: '直营分公司',
						value: 1
					},
					{
						label: '合作加盟',
						value: 2
					},
				],
				priority_list: [{
						label: '普通',
						value: -1
					},
					{
						label: '优先',
						value: 1
					},
				],
				modal: false,
				name: '',
				columns: [{
						title: '下级名称',
						key: 'name',
						width: '150',
						"align":"center",
					},
					{
						title: 'ID',
						key: 'id',
						width: '100',
						"align":"center",
					},
					{
						title: '城市',
						key: 'city',
						width: '100',
						"align":"center",
					},
					{
						title: '类型',
						key: 'channel_type_name',
						width: '100',
						"align":"center",
					},
					{
						title: '开通时间',
						key: 'open_at',
						width: '100',
						"align":"center",
					},
					{
						title: '到期时间',
						key: 'expired_at',
						width: '100',
						"align":"center",
					},
					{
						title: '工号数量',
						key: 'team_nums',
						width: '100',
						"align":"center",
					},
					{
						title: '数据量(天)',
						key: 'day_limit',
						width: '100',
						"align":"center",
					},
					{
						title: '数据开关',
						slot: 'is_open',
						width: '150',
						"align":"center",
					},
					{
						title: '优先级别',
						key: 'priority_name',
						width: '100',
						"align":"center",
					},
					{
						title: '进线时间',
						key: 'quantum',
						width: '100',
						width: '100',
						"align":"center",
					},
					{
						title: '操作',
						slot: 'action',
						width: '130',
						"align":"center",
					},
				],
				data: [],
				clientIdList:[],
			}
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			search() {
				this.page = 1;
				this.loadData();
				this.getList();
			},
			initSearch() {
				this.name = '';
				this.page = 1;
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			saveOpen(e, index) {
				let item = this.data[index];
				let that = this;
				let data = {
					token: this.token,
					id: item.id,
					is_open: item.is_open
				};
				this.throttle(async function() {
					let res = await saveSubsidiaryOpen(that, data);
					if (res.code == 1) {
						that.$Message.success('操作成功');
					}
				}, 200)
			},
			async loadData() {
				let that = this;
				let data = {
					token: that.token
				};
				let res = await getAllCharge(that, data);
				if (res.code == 1) {
					that.functionaryList = res.data.list;
					console.log(that.functionaryList);
				}
				res = await getAllMediumCode(that, data);
				if (res.code == 1) {
					res.data.list.forEach(function(row) {
						that.mediumList.push(row);
					})
				}
				res = await getClientIdList(that, data);
				if (res.code == 1) {
					that.clientIdList = res.data.list;
				}
				
			},
			async getList() {
				let that = this;
				let data = {
					token: that.token,
					page: that.page,
					name: that.name
				};
				let res = await getSubsidiaryList(that, data);
				if (res.code == 1) {
					that.data = res.data.list;
					that.count = res.count;
				}
			},
			// 新增分公司
			addSubsidiary() {
				this.initFormData();
				this.initClientSource();
				this.modal = true
			},
			initFormData() {
				this.filiale = {
					charge_id: '',
					phone_readonly: false,
					name: '',
					created_at: '',
					expired_at: '',
					channel_type: 1,
					day_limit: '',
					city: '',
					quantum: ['9:00', '22:00'],
					settle_type: 1,
					settle_money: '',
					settle_proportion: '',
					phone: '',
					open_at: '',
					team_nums: '',
					team_per_fee: '',
					ext_info: {
						logo: '',
						city: [],
						medium_code_list: [],
					},
					medium_code_list: [],
					sort: '',
				}
			},
			handleCheckAll () {
			    if (this.indeterminate) {
			        this.checkAll = false;
			    } else {
			        this.checkAll = !this.checkAll;
			    }
			    this.indeterminate = false;
			    if (this.checkAll) {
					for(let i in this.mediumList){
						this.filiale.medium_code_list.push(this.mediumList[i].value);
					}
			    } else {
			        this.filiale.medium_code_list = [];
			    }
			},
			checkAllGroupChange (data) {
			    if (data.length === 3) {
			        this.indeterminate = false;
			        this.checkAll = true;
			    } else if (data.length > 0) {
			        this.indeterminate = true;
			        this.checkAll = false;
			    } else {
			        this.indeterminate = false;
			        this.checkAll = false;
			    }
			},
			uploadLogo() {
				this.uploadModal = true
			},
			fileOk() {
				var that = this;
				that.filiale['ext_info']['logo'] = that.$refs['addFile'].fileUrl;
				that.$refs['addFile'].clear();
			},
			// 编辑平台
			async editSubsidiary(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				let data = {
					token: that.token,
					id: id
				};
				let res = await getSubsidiary(that, data);
				if (res.code == 1) {
					that.filiale = res.data.item;
					that.modal = true;
				}
			},
			// 删除平台
			delSubsidiary(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async () => {
						that.throttle(async function() {
							let data = {
								token: that.token,
								id: id
							}
							let res = await delSubsidiary(that, data);
							if (res.code == 1) {
								that.$Message.success('删除成功');
								that.getList();
							}
						}, 1000);
					}
				})
			},
			save() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.filiale
					};
					let res = await saveSubsidiary(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.modal = false;
						that.initFormData();
						that.getList();
					}
				}, 500)
			},
			cancelMediumCode(e, id) {
				let that = this;
				that.filiale.medium_code_list.forEach(function(row, index) {
					if (row.id == id) {
						that.filiale.medium_code_list.splice(index, 1);
					}
				});
			},
			initClientSource() {
				this.client_source = {
					id: '',
					name: '',
					condition_check: 1,
					age: ['', ''],
					sum: ['', ''],
					entry_requirements: []
				}
			},
			addMediumCode() {
				let that = this;
				if (that.client_source.id == '' || typeof that.client_source.id == 'undefined') {
					that.$Message.error('媒体代码不能为空');
					return false;
				}
				if (that.client_source.condition_check == 1 && (that.client_source.age[0] == '' || that.client_source.age[
						1] == '')) {
					that.$Message.error('年龄不能为空');
					return false;
				}
				if (that.client_source.id == 'all') {
					// 全选
					that.filiale.medium_code_list = [];
					that.mediumList.forEach(function(row) {
						if (row.value != 'all') {
							let clientSource = {
								...that.client_source
							};
							clientSource.id = row.value;
							clientSource.name = row.label;
							that.filiale.medium_code_list.push(clientSource);
						}
					})
				} else {
					let check = false;
					that.filiale.medium_code_list.forEach(function(row, index) {
						if (row.id == that.client_source.id) {
							check = index;
						}
					});
					if (check != false) {
						that.filiale.medium_code_list[check] = that.client_source;
					} else {
						that.filiale.medium_code_list.push(that.client_source);
					}
				}
				that.$Message.success('保存成功');
				that.initClientSource();
			},
			changeMediumCode(e) {
				this.client_source.name = e.label;
			},
			editMediumCode(e) {
				let index = e.currentTarget.dataset.index;
				this.client_source = this.filiale.medium_code_list[index];
			}
		}
	}
</script>

<style scoped lang="less">
	.yl-flex {
		display: flex;
		justify-content: space-between;
		padding-bottom: 0;
	}

	.add_flex {
		display: flex;
		align-items: center;
		margin: 10px 0;
	}

	.add_title {
		margin: 0 10px;
		font-weight: bold;
	}

	.ivu-upload {
		display: flex;
		align-items: center;
	}
</style>
